




import {Component, Vue} from 'vue-property-decorator';
import {Sync} from 'vuex-pathify';
import Cart from '@/components/Views/Cart/Cart.vue';

@Component({
    components: {
        Cart,
    },
})
export default class BookingCart extends Vue {
    @Sync('booking/vendors') public vendors!: any[];
    @Sync('booking/dates') public dates!: string[];
    @Sync('booking/times') public times!: number[];
    @Sync('booking/services') public services!: any[];

    public get lineItems(): any[] {
        const out: any[] = [];
        for (let i = 0; i < this.services.length; i++) {
            out.push({
                service: this.services[i],
                date: this.dates[i],
                times: this.times[i],
                vendor: this.vendors[i],
            });
        }
        return out;
    }
}
